import { Component } from '@angular/core';

import { Job } from '../../shared/data/models/collections/job';
import { Request } from '../../shared/data/services/request-enum';
import { AbstractLocalizedComponent } from '../../shared/ui/abstract.localized.component';

@Component({
  selector: 'placeme-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss'],
})
export class JobsComponent extends AbstractLocalizedComponent {
  jobs: Job[];

  protected loadData(locale: string): void {
    this.jobs = null;
    this.collectionsService.query<{ jobs: Job[] }>(Request.JOBS, { locale }).subscribe(data => (this.jobs = data.jobs));
  }
}
